import {
    enableProdMode,
    importProvidersFrom,
    provideZoneChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import { environment } from './environments/environment';
import { RootComponent } from './root.component';
import { RootModule } from './root.module';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(RootComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(RootModule),
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: Lara,
                options: {
                    darkModeSelector: '[data-bs-theme="dark"]',
                },
            },
        }),
    ],
});
